import { isCup } from './imperialUnits.utils';
export function getMeasurementUnit(ingredient, quantity) {
    var _a, _b;
    var correctQuantity = quantity !== null && quantity !== void 0 ? quantity : ingredient === null || ingredient === void 0 ? void 0 : ingredient.quantity;
    var ingredientUnitOfMeasure;
    if ('ingredientUnitOfMeasure' in ingredient) {
        ingredientUnitOfMeasure = ingredient.ingredientUnitOfMeasure;
    }
    else if ('unitOfMeasure' in ingredient) {
        ingredientUnitOfMeasure = ingredient.unitOfMeasure;
    }
    switch (typeof ingredientUnitOfMeasure) {
        case 'string': {
            var lower = ingredientUnitOfMeasure.toLowerCase();
            if (isCup(lower)) {
                return correctQuantity > 1 ? 'cups' : 'cup';
            }
            return lower;
        }
        case 'undefined':
            return '';
        case 'object': {
            if (!ingredientUnitOfMeasure) {
                return '';
            }
            var ingredientUnitOfMeasureObject = ingredientUnitOfMeasure;
            var unit = correctQuantity >= 2
                ? (_a = ingredientUnitOfMeasureObject === null || ingredientUnitOfMeasureObject === void 0 ? void 0 : ingredientUnitOfMeasureObject.plural) === null || _a === void 0 ? void 0 : _a.toLowerCase()
                : (_b = ingredientUnitOfMeasureObject === null || ingredientUnitOfMeasureObject === void 0 ? void 0 : ingredientUnitOfMeasureObject.name) === null || _b === void 0 ? void 0 : _b.toLowerCase();
            return unit !== null && unit !== void 0 ? unit : '';
        }
        default:
            return '';
    }
}
